var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.22656 0.275635C9.28743 0.275635 10.3048 0.697062 11.055 1.44721C11.8051 2.19735 12.2266 3.21477 12.2266 4.27563C12.2266 5.3365 11.8051 6.35392 11.055 7.10406C10.3048 7.85421 9.28743 8.27563 8.22656 8.27563C7.1657 8.27563 6.14828 7.85421 5.39814 7.10406C4.64799 6.35392 4.22656 5.3365 4.22656 4.27563C4.22656 3.21477 4.64799 2.19735 5.39814 1.44721C6.14828 0.697062 7.1657 0.275635 8.22656 0.275635ZM8.22656 10.2756C12.6466 10.2756 16.2266 12.0656 16.2266 14.2756V16.2756H0.226562V14.2756C0.226562 12.0656 3.80656 10.2756 8.22656 10.2756Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserVector);
export default __webpack_public_path__ + "static/media/user-vector.495229a656774d3bde67f3b695b367e0.svg";
export { ForwardRef as ReactComponent };